export default __webpack_public_path__ + "static/media/article9.a7538dce.png";